export default __webpack_public_path__ + "static/metaTrader5-6d6d20ed0a2902d225e0e0a33c8bf947.svg";